// src/tabs/FinanceiroTab.js
import React, { useState, useEffect } from "react";
import { 
  DollarSign, 
  Inbox, 
  Upload, 
  Briefcase, 
  Settings, 
  TrendingUp, 
  TrendingDown, 
  Loader2,
  Activity,
  Clock,
  BookOpen
} from "lucide-react";
import { useFinanceiro } from "../hooks/useFinanceiro";
import LancamentosSubTab from "./LancamentosSubTab";
import ContasAPagarSubTab from "./ContasAPagarSubTab";
import ContasAReceberSubTab from "./ContasAReceberSubTab";
import ConferenciaFinanceiraSubTab from "./ConferenciaFinanceiraSubTab";
import ConciliacaoBancariaSubTab from "./ConciliacaoBancariaSubTab";
import ImportacaoFinanceiraSubTab from "./ImportacaoFinanceiraSubTab";
import FinanciamentosSubTab from "./FinanciamentosSubTab";
import FinanceiroConfigSubTab from "./FinanceiroConfigSubTab";
import RelatoriosSubTab from "./RelatoriosSubTab";
import GuiaUsoSubTab from "./GuiaUsoSubTab";

export default function FinanceiroTab({ user }) {
  const finance = useFinanceiro(user);
  const [activeSubTab, setActiveSubTab] = useState(() => {
    return localStorage.getItem("financeiro_active_subtab") || "lancamentos";
  });

  useEffect(() => {
    localStorage.setItem("financeiro_active_subtab", activeSubTab);
  }, [activeSubTab]);

  return (
    <div className="flex flex-col h-full bg-slate-50 overflow-hidden w-full relative">
      
      {/* ─── NAVEGAÇÃO DE SUB-ABAS ──────────────────────────────────────── */}
      <div className="flex px-4 pt-4 border-b border-slate-200 bg-white gap-2 shrink-0 overflow-x-auto [&::-webkit-scrollbar]:hidden">
        <button
          onClick={() => setActiveSubTab("lancamentos")}
          className={`flex items-center gap-2 px-4 py-2 border-b-2 font-semibold text-sm transition-colors whitespace-nowrap ${
            activeSubTab === "lancamentos"
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-slate-500 hover:text-slate-700"
          }`}
        >
          <DollarSign size={16} /> Lançamentos
        </button>

        <button
          onClick={() => setActiveSubTab("contas_a_pagar")}
          className={`flex items-center gap-2 px-4 py-2 border-b-2 font-semibold text-sm transition-colors whitespace-nowrap ${
            activeSubTab === "contas_a_pagar"
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-slate-500 hover:text-slate-700"
          }`}
        >
          <Clock size={16} /> Contas a Pagar
        </button>

        <button
          onClick={() => setActiveSubTab("contas_a_receber")}
          className={`flex items-center gap-2 px-4 py-2 border-b-2 font-semibold text-sm transition-colors whitespace-nowrap ${
            activeSubTab === "contas_a_receber"
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-slate-500 hover:text-slate-700"
          }`}
        >
          <TrendingUp size={16} /> Contas a Receber
        </button>

        <button
          onClick={() => setActiveSubTab("conferencia")}
          className={`flex items-center gap-2 px-4 py-2 border-b-2 font-semibold text-sm transition-colors whitespace-nowrap ${
            activeSubTab === "conferencia"
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-slate-500 hover:text-slate-700"
          }`}
        >
          <Inbox size={16} /> Conferência
          {finance.pendingCount > 0 && (
            <span className="ml-1 bg-red-500 text-white font-bold text-[10px] px-1.5 py-0.5 rounded-full animate-pulse">
              {finance.pendingCount}
            </span>
          )}
        </button>

        <button
          onClick={() => setActiveSubTab("conciliacao")}
          className={`flex items-center gap-2 px-4 py-2 border-b-2 font-semibold text-sm transition-colors whitespace-nowrap ${
            activeSubTab === "conciliacao"
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-slate-500 hover:text-slate-700"
          }`}
        >
          <Activity size={16} /> Conciliação Bancária
        </button>

        <button
          onClick={() => setActiveSubTab("importacao")}
          className={`flex items-center gap-2 px-4 py-2 border-b-2 font-semibold text-sm transition-colors whitespace-nowrap ${
            activeSubTab === "importacao"
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-slate-500 hover:text-slate-700"
          }`}
        >
          <Upload size={16} /> Importar Planilha
        </button>

        <button
          onClick={() => setActiveSubTab("financiamentos")}
          className={`flex items-center gap-2 px-4 py-2 border-b-2 font-semibold text-sm transition-colors whitespace-nowrap ${
            activeSubTab === "financiamentos"
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-slate-500 hover:text-slate-700"
          }`}
        >
          <Briefcase size={16} /> Financiamentos
        </button>

        <button
          onClick={() => setActiveSubTab("relatorios")}
          className={`flex items-center gap-2 px-4 py-2 border-b-2 font-semibold text-sm transition-colors whitespace-nowrap ${
            activeSubTab === "relatorios"
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-slate-500 hover:text-slate-700"
          }`}
        >
          <TrendingUp size={16} /> Relatórios
        </button>

        <button
          onClick={() => setActiveSubTab("guia_uso")}
          className={`flex items-center gap-2 px-4 py-2 border-b-2 font-semibold text-sm transition-colors whitespace-nowrap ${
            activeSubTab === "guia_uso"
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-slate-500 hover:text-slate-700"
          }`}
        >
          <BookOpen size={16} /> Guia de Uso
        </button>

        <button
          onClick={() => setActiveSubTab("config")}
          className={`flex items-center gap-2 px-4 py-2 border-b-2 font-semibold text-sm transition-colors whitespace-nowrap ${
            activeSubTab === "config"
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-slate-500 hover:text-slate-700"
          }`}
        >
          <Settings size={16} /> Configurações
        </button>
      </div>

      {/* ─── LOADER GLOBAL DO FINANCEIRO ────────────────────────────────── */}
      {finance.loading && (
        <div className="absolute inset-0 bg-slate-900/10 backdrop-blur-[1px] flex items-center justify-center z-50 pointer-events-auto">
          <div className="bg-white p-4 rounded-xl shadow-xl border border-slate-100 flex items-center gap-3">
            <Loader2 className="animate-spin text-blue-600" size={24} />
            <span className="font-bold text-sm text-slate-700">Processando...</span>
          </div>
        </div>
      )}

      {/* ─── CONTEÚDO RENDERIZADO ────────────────────────────────────────── */}
      <div className="flex-1 overflow-hidden flex flex-col">
        {activeSubTab === "lancamentos" && (
          <LancamentosSubTab finance={finance} />
        )}

        {activeSubTab === "contas_a_pagar" && (
          <ContasAPagarSubTab finance={finance} />
        )}

        {activeSubTab === "contas_a_receber" && (
          <ContasAReceberSubTab finance={finance} />
        )}

        {activeSubTab === "conferencia" && (
          <ConferenciaFinanceiraSubTab finance={finance} />
        )}

        {activeSubTab === "conciliacao" && (
          <ConciliacaoBancariaSubTab finance={finance} />
        )}

        {activeSubTab === "importacao" && (
          <ImportacaoFinanceiraSubTab finance={finance} />
        )}

        {activeSubTab === "financiamentos" && (
          <FinanciamentosSubTab finance={finance} />
        )}

        {activeSubTab === "relatorios" && (
          <RelatoriosSubTab finance={finance} />
        )}

        {activeSubTab === "guia_uso" && (
          <GuiaUsoSubTab finance={finance} />
        )}

        {activeSubTab === "config" && (
          <FinanceiroConfigSubTab finance={finance} />
        )}
      </div>
    </div>
  );
}
